<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer013">
<h1 class="Title" id="_idParaDest-2"><a id="_idTextAnchor001"><span class="intro">Introduction</span></a></h1><a id="_idTextAnchor001">
</a></div><a id="_idTextAnchor001">
<div class="Basic-Text-Frame" id="_idContainer014">
<p class="Normal-no-indent"><strong class="Strong _idGenCharOverride-2">The funny thing
					is,</strong> I have never really been a person with a “sweet tooth.” In fact, I
				am more likely to decline dessert and opt for an extra serving of something salty,
				crispy, and savory over something sugary, creamy, and rich. </p>
<p class="Normal">So you might be reading this and wondering: Why on earth did you write
				a book on desserts then? Because, when I do have a rare hankering for something
				sweet, I basically live by this motto: <em class="Emphasis _idGenCharOverride-2">just go for it.</em>
</p>
<p class="Normal">But it’s not an all-you-can-eat binge fest on sugar and fat. Instead,
				they’re actual desserts that still have the <em class="Emphasis _idGenCharOverride-2">Naturally</em> ethos of adding in
				nutrition (like veggies and high fiber grains), using real, wholesome ingredients,
				and steering clear of artificial flavors and colors in the recipes. They’re worth
				the calories and lightened up just enough to lessen the guilt. </p>
<p class="Normal">And these desserts have to be worth the time to make, too. In an
				increasingly busy world, I wanted all of the recipes to be simple, but not dumbed
				down. Just that right balance of being able to look at all the steps and ingredients
				and come to a conclusion that you could make it and you could make it right. No
				hard-to-find ingredients and no special tools only a James Beard-worthy pastry chef
				would have in their arsenal. </p>
<p class="Normal">What is in <em class="Emphasis _idGenCharOverride-2">Naturally,
					Delicious Desserts</em> is a compendium of my top 100 sweet treats we’ve
				published in the pages of the magazine. I’ve also baked many of these on the set of
				my TV show, so if you’ve watched and didn’t have a pen and paper handy, now you’ve
				got one place to find all of those recipes. There’s also enough variety and ideas
				here for you to find a treasure trove of new favorites and to be inspired to lighten
				some old-fashioned recipes you might have that are passed down from generation to
				generation. I mean, who knew you could make your own Twix bars that taste better
				than the store-bought version? Or slip eggplant into brownies because it makes it
				fudgier and just better? And who wouldn’t love giant blue marshmallows to garnish a
				piping hot cup of coffee or toasted and melted in between graham crackers and
				chocolate? Oh, yeah . . . you can make your own marshmallows, and it’s easy, too! </p>
<p class="Normal">I’m definitely a friend of desserts, not a fiend. And when you try
				something from this book, I hope you’ll find they are friendly for your health,
				friendly for the planet and—yes—will make friends to satisfy your sweet tooth, too. </p>
<p class="Normal">Let’s celebrate something sweet together. </p>
<p class="attribution">-Danny Seo</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer015">
<img alt="Photo of author." class="_idGenObjectAttribute-4" src="image/20191017_NaturallyMagazineWinter-8.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer016">
<blockquote class="Caption">Photograph by Rikki Snyder</blockquote>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Naturally_Delicious_Desserts_Interiors-1.vue?6072b2e7